import React, { useState, useEffect } from "react";
import logo from "url:../images/tpsiteTpLogo.png";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [active, setActive] = useState("hero");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
      const sections = ["hero", "about", "our-team", "contact"];
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && window.scrollY >= el.offsetTop - 100) {
          setActive(sections[i]);
          break;
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navClick = (e, id) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
    setActive(id);
  };

  const navItems = [
    { id: "hero", label: "Home" },
    { id: "about", label: "About" },
    { id: "our-team", label: "Our Team" },
    { id: "contact", label: "Contact" }
  ];

  return (
    <header id="header" className={`fixed-top ${scrolled ? "header-scrolled" : ""}`}>
      <div className="container d-flex align-items-center justify-content-between">
        <a href="#hero" className="logo" onClick={e => navClick(e, "hero")}>
          <img src={logo} alt="Techport13 Logo" className="img-fluid" />
        </a>
        <nav id="navbar" className="navbar">
          <ul className={mobileOpen ? "navbar-mobile" : ""}>
            {navItems.map(item => (
              <li key={item.id}>
                <a
                  className={`nav-link scrollto ${active === item.id ? "active" : ""}`}
                  href={`#${item.id}`}
                  onClick={e => navClick(e, item.id)}
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a className="nav-link" href="https://careers.techport13.com">Careers</a>
            </li>
          </ul>
          <i
            className={`bi ${mobileOpen ? "bi-x" : "bi-list"} mobile-nav-toggle`}
            onClick={() => setMobileOpen(!mobileOpen)}
          ></i>
        </nav>
      </div>
    </header>
  );
}

export default Header;
